import { render, staticRenderFns } from "./DraggableFilterTab.vue?vue&type=template&id=cb788cfe&scoped=true"
import script from "./DraggableFilterTab.vue?vue&type=script&lang=js"
export * from "./DraggableFilterTab.vue?vue&type=script&lang=js"
import style0 from "./DraggableFilterTab.vue?vue&type=style&index=0&id=cb788cfe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb788cfe",
  null
  
)

export default component.exports